<svg
  id="0fa3c922-2890-4e83-a6a7-5bb6074ca9fa"
  data-name="Layer 1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="300"
  height="300"
  viewBox="0 0 1059.13 789.41"
>
  <defs>
    <linearGradient
      id="5f966abe-ca91-49e1-9c3c-162f077ee9a1"
      x1="602.85"
      y1="654.57"
      x2="602.85"
      y2="287.56"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stop-color="gray" stop-opacity="0.25" />
      <stop offset="0.54" stop-color="gray" stop-opacity="0.12" />
      <stop offset="1" stop-color="gray" stop-opacity="0.1" />
    </linearGradient>
  </defs>
  <title>studying</title>
  <path
    d="M1112.21,406.81c-.19,1.12-.38,2.24-.59,3.36-6.78,38.14-17.85,74.91-34.31,108.67q-.81,1.68-1.65,3.36A310.57,310.57,0,0,1,1037,581.82c-8.2,9.89-17.14,19.28-27.77,26.06-14.9,9.5-32.32,13.36-49.44,16.52-17.79,3.29-35.81,6-53.79,9q-9.56,1.56-19,3.27c-17.37,3.14-34.61,6.77-51.44,11.58-20.81,6-41,13.73-60,24.68q-2.28,1.3-4.51,2.67c-1.49.9-3,1.82-4.45,2.76s-2.91,1.87-4.35,2.82l-2.22,1.5c-.73.48-1.45,1-2.17,1.48-2.14,1.46-4.25,3-6.36,4.48l-.08.06c-1.39,1-2.77,2-4.15,3-7.79,5.77-15.41,11.81-23,17.87l-4.79,3.83q-3.71,2.94-7.42,5.87c-1.45,1.15-2.92,2.29-4.38,3.43-1.06.83-2.11,1.66-3.19,2.48-5.41,4.17-10.89,8.25-16.48,12.15-1.33.93-2.68,1.86-4,2.77a210.89,210.89,0,0,1-35.54,19.58l-.16.07a141,141,0,0,1-18.88,6.51c-3.69,1-7.38,1.79-11.12,2.41a98.28,98.28,0,0,1-30.15.52c-19.69-2.79-38.14-12-57.78-15.08-40.52-6.29-79.87,14-118,29.93q-14,5.86-28.31,11-9.48,3.42-19.05,6.51a599.78,599.78,0,0,1-119.53,25.57c-16.58,1.81-33.87,2.67-50.75,1.37a171.42,171.42,0,0,1-19-2.47c-21.37-4-41.32-12.49-57.39-28C105,785.33,95.58,768.74,88.4,751.43Q84.07,741,80.77,730.09A238,238,0,0,1,73,695.26c-.39-2.66-.74-5.33-1-8q-.78-6.87-1.16-13.8a239,239,0,0,1,7.11-73c6.81-26.39,18.17-51.66,23.17-78.3.21-1.12.4-2.24.59-3.36q1-6,1.52-12.22C105.75,474,96,442.11,88.3,410.17c-.27-1.12-.54-2.24-.8-3.36q-1.25-5.31-2.37-10.63C78,362.4,76.05,326.25,82.38,292.54c.2-1.12.43-2.25.66-3.36,4.27-20.88,11.81-40.74,23.36-58.43,11.85-18.16,27.41-33.27,44-46.55q12.15-9.7,25.13-18.15,9.33-6.06,19-11.47c52.09-29,111.52-43.17,170.28-40q4.67.24,9.32.64,4.88.42,9.73,1c37.83,4.37,74.64,15.2,111.23,27.05,12.26,4,24.49,8,36.72,12q8.16,2.66,16.31,5.25c26.65,8.41,53.74,16,81.08,21.72q9.51,2,19,3.65a449.08,449.08,0,0,0,66.59,6.86q13,.32,26-.27,6.57-.3,13.15-.88c45.31-3.88,89-16.89,132.87-29.11,6.34-1.77,12.69-3.53,19-5.23,8.34-2.24,16.69-4.41,25.07-6.41,52.18-12.53,98.68-5.33,147.19,20.51,11,5.87,22,12.95,28.8,23.91s8.45,24.53,9.71,37.59c1.78,18.58,3,37.42,3.39,56.34,0,1.12,0,2.24.07,3.36C1120.92,330.87,1118.59,369.47,1112.21,406.81Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M766.12,518.84h-3.41v1.49l0,1.87h3.86Zm-38.65,0a.22.22,0,0,0,0,.08l-.3,2.78,0,.25,0,.25h29.6V522l2.11-3.16Zm-79.15,0V410.17h34c-.36-.3-.73-.6-1.11-.88l-.5-.38c-.21-.17-.42-.33-.64-.48s-.74-.53-1.13-.79-.63-.43-1-.64l-.23-.15-.05,0H648.32v-5.95l-.79.38-.84.47-.06,0-.18.11-.52.34c-.18.11-.36.22-.53.34-.52.35-1,.73-1.55,1.12l-.5.4c-.34.26-.66.53-1,.8-1.33,1.09-2.64,2.23-4,3.28-.34.27-.68.53-1,.78a25.81,25.81,0,0,1-2.26,1.48,10.74,10.74,0,0,1-1,.55l-.56.26-.51.22h0a21.24,21.24,0,0,1-3.72,1.18V518.84h-51c0,.12.07.23.1.35.28,1,.56,2,.83,3h50.08V638.68l.78,0,.89.06,1.62.12,2.62.26,1.18.14,1.3.16.19,0c.75.1,1.51.22,2.28.34l.49.08,1.1.18,1.58.28h0l3.79-.2h0l.52.11c.21,0,.42.08.64.13V522.2H727.1l0-.25,0-.25.3-2.78a.22.22,0,0,1,0-.08Zm117.8,0h-3.41v1.49l0,1.87h3.86Zm-40.78,0L725,522.2h32.93l2.24-3.36Zm-77,0V410.17h34c-.36-.3-.73-.6-1.11-.88l-.5-.38c-.21-.17-.42-.33-.64-.48s-.74-.53-1.13-.79-.63-.43-1-.64l-.23-.15-.07,0H648.32v-5.95l-.79.38-.84.47-.06,0-.18.11-.52.34c-.18.11-.36.22-.53.34-.52.35-1,.73-1.55,1.12l-.5.4c-.34.26-.66.53-1,.8-1.33,1.09-2.64,2.23-4,3.28-.34.27-.68.53-1,.78a25.81,25.81,0,0,1-2.26,1.48,10.74,10.74,0,0,1-1,.55l-.56.26-.51.22h0a21.24,21.24,0,0,1-3.72,1.18V518.84h-51c0,.12.07.23.1.35.28,1,.57,2,.84,3h50.07V638.67l.78.05.89.06,1.62.12,2.62.26,1.18.14,1.3.16.19,0c.75.1,1.51.22,2.28.34l.49.08,1.1.18,1.58.28h0l3.79-.2h0l.52.11c.21,0,.42.08.64.13V522.2H725l.36-3.36ZM906,292.54h214.23c0-1.12,0-2.24-.07-3.36H906V157.24c-6.36,1.7-12.71,3.46-19,5.23V289.18H654l-.59-.64.89-1h0l86.66-95.11q-13,.6-26,.27L648.32,265.8V185.87q-9.54-1.65-19-3.65v79.9L531.89,155.25c-12.23-4-24.46-8.07-36.72-12L627.6,288.54l-.59.64H383.94v-173q-4.86-.55-9.73-1-4.65-.41-9.32-.64V289.18H194.61V154.58q-9.69,5.4-19,11.47V289.18H83c-.23,1.11-.46,2.24-.66,3.36h93.19V406.81H87.5c.26,1.12.53,2.24.8,3.36h87.27V518.84H101.68c-.19,1.12-.38,2.24-.59,3.36h74.48V826.05a171.42,171.42,0,0,0,19,2.47V522.2H364.89V801.58q9.58-3.11,19.05-6.51V522.2H629.28V766.3a141,141,0,0,0,18.88-6.51l.16-.07V522.2H886.94V636.67q9.49-1.71,19-3.27V522.2h169.67q.84-1.68,1.65-3.36H906V410.17h205.63c.21-1.12.4-2.24.59-3.36H906Zm-711.38,0H364.89V406.81H194.61Zm0,226.3V410.17H364.89V518.84Zm189.33-226.3H629.28V406.81H383.94Zm0,226.3V410.17H629.28V518.84Zm503,0H648.32V410.17H886.94Zm0-112H648.32V295.6l3.35-3.06H886.94Zm-159.47,112a.22.22,0,0,0,0,.08l-.3,2.78,0,.25,0,.25h29.6V522l2.11-3.16Zm38.65,0h-3.41v1.49l0,1.87h3.86Zm-117.8,0V410.17h34c-.36-.3-.73-.6-1.11-.88l-.5-.38c-.21-.17-.42-.33-.64-.48s-.74-.53-1.13-.79-.63-.43-1-.64l-.23-.15-.05,0H648.32v-5.95l-.79.38-.84.47-.06,0-.18.11-.52.34c-.18.11-.36.22-.53.34-.52.35-1,.73-1.55,1.12l-.5.4c-.34.26-.66.53-1,.8-1.33,1.09-2.64,2.23-4,3.28-.34.27-.68.53-1,.78a25.81,25.81,0,0,1-2.26,1.48,10.74,10.74,0,0,1-1,.55l-.56.26-.51.22h0a21.24,21.24,0,0,1-3.72,1.18V518.84h-51c0,.12.07.23.1.35.28,1,.56,2,.83,3h50.08V638.68l.78,0,.89.06,1.62.12,2.62.26,1.18.14,1.3.16.19,0c.75.1,1.51.22,2.28.34l.49.08,1.1.18,1.58.28h0l3.79-.2h0l.52.11c.21,0,.42.08.64.13V522.2H727.1l0-.25,0-.25.3-2.78a.22.22,0,0,1,0-.08Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M276.48,213.86H278a3.64,3.64,0,0,1-1.81-2.93h0c0-2.32,2.84-4.21,6.31-4.21h44.15c3.47,0,6.31,1.89,6.31,4.21h0c0,2.31-2.84,4.21-6.31,4.21h-1.47a3.65,3.65,0,0,1,1.8,2.93c0,2-2.06,3.64-4.82,4.09h12.71c3.46,0,6.3,1.89,6.3,4.21s-2.84,4.2-6.3,4.2H290.67c-3.46,0-6.3-1.89-6.3-4.2,0-2,2.06-3.64,4.82-4.09H276.48c-3.46,0-6.3-1.89-6.3-4.21S273,213.86,276.48,213.86Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M755,253.93h1.48a3.65,3.65,0,0,1-1.81-2.94h0c0-2.31,2.84-4.2,6.31-4.2h44.15c3.47,0,6.31,1.89,6.31,4.2h0c0,2.32-2.84,4.21-6.31,4.21h-1.47a3.66,3.66,0,0,1,1.8,2.94c0,2-2.06,3.63-4.82,4.08h12.71c3.46,0,6.3,1.9,6.3,4.21s-2.84,4.21-6.3,4.21H769.21c-3.46,0-6.3-1.89-6.3-4.21,0-2,2.06-3.64,4.82-4.08H755c-3.46,0-6.3-1.9-6.3-4.21S751.56,253.93,755,253.93Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M208.75,425.4h1.48a3.66,3.66,0,0,1-1.8-2.94h0c0-2.31,2.83-4.21,6.3-4.21h44.15c3.47,0,6.31,1.9,6.31,4.21h0c0,2.32-2.84,4.21-6.31,4.21h-1.47a3.66,3.66,0,0,1,1.8,2.94c0,2-2.06,3.63-4.82,4.08H267.1c3.47,0,6.3,1.89,6.3,4.21s-2.83,4.21-6.3,4.21H222.94c-3.46,0-6.3-1.9-6.3-4.21,0-2,2.07-3.64,4.82-4.09H208.75c-3.46,0-6.3-1.89-6.3-4.2S205.29,425.4,208.75,425.4Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M719.36,713.44q-3.71,2.94-7.42,5.87c-1.45,1.15-2.92,2.29-4.38,3.43-1.06.83-2.11,1.66-3.19,2.48-5.41,4.17-10.89,8.25-16.48,12.15-1.33.93-2.68,1.86-4,2.77a210.89,210.89,0,0,1-35.54,19.58l-.16.07V713.44Z"
    transform="translate(-70.44 -55.29)"
    fill="#65617d"
  />
  <path
    d="M830.64,531.28l1.12-34.55c-.67-.52-1.35-1-2-1.48A184.18,184.18,0,0,0,828,464.44c-4.52-34.55-33.87-35.3-42.15-28.17a20,20,0,0,1-3.57,2.46c.75-4.93,1.68-9.87,2.35-14.75,3.62-26.32-2-55.93-22.42-72.94-8.55-7.11-19-11.48-28.39-17.43C717,323,703.71,307.33,686.7,297s-40.9-14.2-55.74-.92c-5.75,5.14-9.46,12.27-15.36,17.23-11,9.24-28.15,9.85-37.75,20.17h0c-.48.52-.94,1.05-1.38,1.61-8,10.26-5.81,24.81-3.26,37.54,3.07,15.32,1.8,27.6,14.94,32,.05.61.09,1.22.16,1.82a64.91,64.91,0,0,0,28.56,46.72l-2.13.76c-5.68,2-10.79,3.94-14.06,5.27-12,4.89-37.26,11.26-37.26,11.26s-.6,7.2-.49,17.82c-8.42,9.15-22.47,25.23-26.6,34.76-6,13.9-39.9,53.71-48.93,59.72s-18.82,13.14-18.82,13.14-14.3,7.89-21.07,8.64c-4.69.52-19.2-2.26-19.2-2.26s-57.95-71-54.19-16.52,50.05,56.33,50.05,56.33l46.67-.75s25.22,3.38,36.51-6c9.64-8,59.6-51.89,75.65-71.8.37.41.74.81,1.13,1.2,0,0,6.39-8.26,7.15,0s-4.15,12-1.51,15,10.54,13.52,10.91,17.65-10.53,21,7.9,33.8c.29.2.6.39.94.58,3.29,7.49,13.75,14.82,13.75,14.82l56.45-.75,106.51,8.26s3.17-2.79,7.46-7.35c5.73,5.26,13.68,9.77,22.64,7,0,0,12.8-15.39,13.18-25.53,0,0-8.28-21.41-12-27.79s2.64-20.28,2.64-20.28,4.51-13.52,7.15-13.52.75-9,.75-9a10.94,10.94,0,0,1-1.13-10.14C829.13,541.8,830.64,531.28,830.64,531.28Z"
    transform="translate(-70.44 -55.29)"
    fill="url(#5f966abe-ca91-49e1-9c3c-162f077ee9a1)"
  />
  <path
    d="M766.79,523.5l-4,4.68h0L746.63,547l-21.11,1.28-33.79,2.08s-45.56-54.9-37-66.85c3.11-4.31,3.62-10,3-15.37-.08-.74-.19-1.48-.32-2.21a63.89,63.89,0,0,0-5.32-16.4l1.12-.51.72-.33,39.84-18.18,9.86-4.5a26.62,26.62,0,0,0,2.7,7.78c.19.38.4.76.62,1.12,13.59,22.5,57.17,8.27,57.17,8.27Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M825.7,495.41c-.3,13.62-2.52,19.5-2.52,19.5l-56.39,8.59-2.11-14.64-8.35-57.81,7.84-7.84a20.93,20.93,0,0,0,17.93-4.48c8.21-7.1,37.34-6.35,41.82,28A190.13,190.13,0,0,1,825.7,495.41Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M812.35,654.94s12.69-15.31,13.07-25.39l-12.7-21.29-11.2-12L780.6,636.64S794.42,660.54,812.35,654.94Z"
    transform="translate(-70.44 -55.29)"
    fill="#dfe5ee"
  />
  <path
    d="M812.35,654.94s12.69-15.31,13.07-25.39l-12.7-21.29-11.2-12L780.6,636.64S794.42,660.54,812.35,654.94Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M707.56,722.74c-1.06.83-2.11,1.66-3.19,2.48-5.41,4.17-10.89,8.25-16.48,12.15-1.33.93-2.68,1.86-4,2.77H629.28l-245.34,0H364.89l-94.38-3.38-75.9-.64-19-1-94.8-5A238,238,0,0,1,73,695.26c-.39-2.66-.74-5.33-1-8L175.57,693l19,1.07,170.28,9.5,19.05,1.06,245.34,13.7,18.88,1.06h.16Z"
    transform="translate(-70.44 -55.29)"
    fill="#d48a9b"
  />
  <path
    d="M835.5,648.25c-20.81,6-41,13.73-60,24.68-1.51.87-3,1.76-4.51,2.67s-3,1.82-4.45,2.76-2.91,1.87-4.35,2.82l-2.22,1.5-2.17,1.48c-2.14,1.47-4.25,3-6.36,4.48l-.08.06c-1.39,1-2.77,2-4.15,3-7.79,5.77-15.41,11.81-23,17.87q-2.4,1.92-4.81,3.83l-7.4,5.87c-1.45,1.15-2.92,2.29-4.38,3.43-1.06.83-2.11,1.66-3.19,2.48l-56-2.67h-.16l-18.88-.88L383.94,710l-19.05-.91L194.61,701l-19-.91L73,695.26c-.39-2.66-.74-5.33-1-8q-.78-6.87-1.16-13.8l104.76-37,19-6.73,17.26-6.1,31.45,1.64L316,629h0l48.92,2.57,19.05,1,12.17.64h0l2.91.16h0l102.42,5.35h0l1.08.07h0l45.7,2.38.52,0,.3,0h0l4.57.23h0l15.58.82,19.48,1h0l6.42.34h0l1.21.07,9.08.47h0l2.59.13h0l8.67.46h0l3.45.19h.11l.72,0h0l8.11.43,12.56.66h.06l3.9.2H646l2.33.13,5.72.3h0l5,.26h.05l5.61.29h.09l4.25.23h0l3.26.17,11.57.61h0l2.08.11.72,0,1,.06h0l3.39.18h0l1.52.08h0l11.8.61h1.08l17.42-.15h.12l66.23-.54h0l1.27,0h1.34l3.94,0h0l21.32-.17,3.18,0Z"
    transform="translate(-70.44 -55.29)"
    fill="#efc6cd"
  />
  <path
    d="M388.51,649.62l6.16,32.77,167.48-2.52s12.6,3.64,12.32-6.44c0,0,25.49-24.09,154.6,3.92L679.5,638.42,544,645.7l-157.12-4.2Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
  />
  <path
    d="M391.59,641.78l5.88,35.57s144-4.2,166.64-.28L547,644.58S459.93,636.46,391.59,641.78Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M391.59,641.78l5.88,35.57s144-4.2,166.64-.28L547,644.58S459.93,636.46,391.59,641.78Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M393.74,641.65l5.8,33.08s142.17-3.9,164.57-.26l-16.87-30.21S461.22,636.7,393.74,641.65Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M396.35,642.67,402,673.61s139.05-3.65,161-.24l-16.5-28.27S462.36,638,396.35,642.67Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M397.47,641.54l5.68,31s139.05-3.65,161-.24L547.61,644S463.48,636.91,397.47,641.54Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M299.09,557.41s7.28,9.51-3.35,23.88-19.41,26.49-15.86,35.45c0,0,16-26.68,29.1-27S313.46,573.45,299.09,557.41Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
  />
  <path
    d="M299.09,557.41a11.56,11.56,0,0,1,1.49,3c12.74,15,19.53,29,7.28,29.3-11.41.32-25.09,20.72-28.37,25.88q.17.58.39,1.17s16-26.68,29.1-27S313.46,573.45,299.09,557.41Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M312.62,569.54c0,3.34-.38,6.06-.84,6.06s-.84-2.72-.84-6.06.47-1.78.93-1.78S312.62,566.19,312.62,569.54Z"
    transform="translate(-70.44 -55.29)"
    fill="#ffd037"
  />
  <path
    d="M317.26,573.53c-2.94,1.61-5.5,2.58-5.72,2.17s2-2,4.92-3.64,1.78-.44,2,0S320.2,571.93,317.26,573.53Z"
    transform="translate(-70.44 -55.29)"
    fill="#ffd037"
  />
  <path
    d="M260.66,557.41s-7.28,9.51,3.36,23.88,19.4,26.49,15.86,35.45c0,0-16.05-26.68-29.11-27S246.29,573.45,260.66,557.41Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
  />
  <path
    d="M260.66,557.41a12,12,0,0,0-1.49,3c-12.74,15-19.53,29-7.28,29.3,11.41.32,25.1,20.72,28.38,25.88q-.16.58-.39,1.17s-16.05-26.68-29.11-27S246.29,573.45,260.66,557.41Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M247.13,569.54c0,3.34.38,6.06.84,6.06s.84-2.72.84-6.06-.47-1.78-.93-1.78S247.13,566.19,247.13,569.54Z"
    transform="translate(-70.44 -55.29)"
    fill="#ffd037"
  />
  <path
    d="M242.49,573.53c2.94,1.61,5.51,2.58,5.73,2.17s-2-2-4.92-3.64-1.78-.44-2,0S239.55,571.93,242.49,573.53Z"
    transform="translate(-70.44 -55.29)"
    fill="#ffd037"
  />
  <path
    d="M319,603.91l-.36,3-.51,4.19-.21,1.75-.51,4.2-.22,1.75-.52,4.2-5.82,47.72c-.52,4.26-7.48,7.58-15.88,7.58H264.75c-8.4,0-15.35-3.32-15.87-7.58L243.05,623l-.51-4.2-.21-1.75-.52-4.2-.21-1.75-.51-4.19-.37-3c-.29-2.41,3.47-4.44,8.23-4.44h61.86C315.56,599.47,319.33,601.5,319,603.91Z"
    transform="translate(-70.44 -55.29)"
    fill="#65617d"
  />
  <polygon
    points="248.23 551.59 247.72 555.79 171.16 555.79 170.65 551.59 248.23 551.59"
    fill="#9d9cb5"
  />
  <polygon
    points="247.51 557.54 247 561.74 171.89 561.74 171.37 557.54 247.51 557.54"
    fill="#9d9cb5"
  />
  <polygon
    points="246.78 563.49 246.27 567.68 172.61 567.68 172.1 563.49 246.78 563.49"
    fill="#9d9cb5"
  />
  <path
    d="M411.29,600.05s-19.42-18.67-18.67,5.6S411.29,600.05,411.29,600.05Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M585.68,557.48c-.43,1.88-2.52,5-5.78,8.91-16.84,20.28-64.75,62.43-74.14,70.25-11.2,9.34-36.22,6-36.22,6l-46.3.75s-45.93-1.87-49.67-56,53.77,16.43,53.77,16.43,14.4,2.76,19.05,2.24c6.72-.74,20.91-8.58,20.91-8.58s9.71-7.1,18.67-13.07,42.57-45.56,48.55-59.38c3.79-8.77,16-23.11,24.43-32.41,4.84-5.35,8.43-9,8.43-9S588.29,545.9,585.68,557.48Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M585.68,557.48c-.43,1.88-2.52,5-5.78,8.91-17-17.31-20.55-51.85-20.95-73.81,4.84-5.35,8.43-9,8.43-9S588.29,545.9,585.68,557.48Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M762.78,528.18h0L746.63,547l-21.11,1.28-33.79,2.08s-45.56-54.9-37-66.85c3.11-4.31,3.62-10,3-15.37-.08-.74-.19-1.48-.32-2.21a63.89,63.89,0,0,0-5.32-16.4l1.12-.51.72-.33A71.71,71.71,0,0,1,657.59,464c.11.71.21,1.45.31,2.21.35,2.7.67,5.7,1,9,2.6,30.22,21.61,41.59,30.19,45.21a87.07,87.07,0,0,1,8.08,3.91,43.11,43.11,0,0,0,27.1,4.9c21.18-2.78,38.45-18.17,38.45-18.17l.09,15.15Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M763.43,645.61s-138.91-.38-157.22-13.07-7.46-29.5-7.84-33.61-8.21-14.56-10.82-17.56,2.24-6.72,1.49-14.93-7.09,0-7.09,0c-26.15-26.52-20.55-93.73-20.55-93.73s25-6.34,37-11.21c3.25-1.32,8.31-3.2,14-5.23l2.11-.76c14.67-5.25,32.11-11.18,32.11-11.18s3.35-2.37,6.72,4.72c1.54,3.26,3.09,8.51,4.33,16.9.11.71.21,1.45.31,2.21.35,2.7.67,5.7,1,9,2.6,30.22,21.61,41.59,30.19,45.21a87.07,87.07,0,0,1,8.08,3.91,43.11,43.11,0,0,0,27.1,4.9c21.18-2.78,38.45-18.17,38.45-18.17l.09,15.15.26,45.52Z"
    transform="translate(-70.44 -55.29)"
    fill="#dfe5ee"
  />
  <path
    d="M757.45,586.61l-2.24,14.19s-55.27,13.81-76.92,17.92-68.34-1.12-71.7,7.84,14.19,21.29,14.19,21.29l56-.75,105.68,8.22s40.33-35.48,27.26-60.13S757.45,586.61,757.45,586.61Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M643.56,474.58s-25.4,20.91-20.54,31S643.56,474.58,643.56,474.58Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M612.19,512.29s-25.77,44.44-24.27,47.8,8.59,15.31,8.21,6.35S612.19,512.29,612.19,512.29Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M622.65,520.14s-6,27.63-11.95,39.21S622.65,520.14,622.65,520.14Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M707,434.94a64.6,64.6,0,0,1-49.1,33.22h-.12a64.49,64.49,0,0,1-45.46-11.9c15-5.42,34.22-11.94,34.22-11.94s3.35-2.37,6.72,4.72l50.42-23A26.73,26.73,0,0,0,707,434.94Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M714.88,401.76a64.31,64.31,0,0,1-8.5,32.06,65.07,65.07,0,0,1-9.63,12.82A64.33,64.33,0,0,1,657.59,466h-.13a63.07,63.07,0,0,1-7.18.41,64.6,64.6,0,0,1-64.19-57.32,62.74,62.74,0,0,1-.41-7.29,64.6,64.6,0,1,1,129.2,0Z"
    transform="translate(-70.44 -55.29)"
    fill="#ee8e9e"
  />
  <path
    d="M756.71,524l6-9s32.86-39.21,65-14.19l-1.12,34.36s-1.5,10.45-3.74,16a10.93,10.93,0,0,0,1.12,10.09s1.87,9-.74,9-7.1,13.44-7.1,13.44-6.35,13.82-2.61,20.17,11.95,27.63,11.95,27.63-13.07-7.84-16.81-20.91c0,0-31.74-24.65-56.39-9Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M825.7,495.41c-.3,13.62-2.52,19.5-2.52,19.5l-56.39,8.59-2.11-14.64C772.06,501.16,798.9,476.68,825.7,495.41Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M756.71,522l6-9s32.86-39.21,65-14.19l-1.12,34.36s-1.5,10.45-3.74,16a10.93,10.93,0,0,0,1.12,10.09s1.87,9-.74,9-7.1,13.44-7.1,13.44-6.35,13.82-2.61,20.17,11.95,27.63,11.95,27.63-13.07-7.84-16.81-20.91c0,0-31.74-24.65-56.39-9Z"
    transform="translate(-70.44 -55.29)"
    fill="#dfe5ee"
  />
  <path
    d="M809.73,496.61S755.59,529.85,758.2,559C758.2,559,788.45,505.57,809.73,496.61Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M762.77,528.19l.26,45.52c-10.24.46-19.89-.87-27.52-7.5-5.31-4.62-8.4-11-10-17.9a63.41,63.41,0,0,1-1.3-16.93.91.91,0,0,1,0-.17c.63-12.57,3.52-25.14,2-37.63s-9.09-25.67-21.45-28.3c-2.44-.53-5.18-.72-6.92-2.51-1.92-2-1.83-5.11-1.62-7.88l.36-4.67c.09-1.2.13-2.39.13-3.58a45.83,45.83,0,0,0-37-44.94l-.4-.07c-3.48-.7-7.1-1.39-10.58-.59-6.62,1.53-10.9,7.95-17,11-11.7,5.84-31.21-.55-43.46-2.56-.8-.13-1.56-.28-2.29-.45a62.74,62.74,0,0,1-.41-7.29,64.6,64.6,0,1,1,120.7,32.06c.19.38.4.76.62,1.12,13.59,22.5,57.17,8.27,57.17,8.27l2.62,80.29Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M634.08,410.93c6.06-3.06,10.34-9.48,17-11,3.47-.8,7.09-.11,10.59.58l.4.08a45.87,45.87,0,0,1,36.83,48.53l-.36,4.67c-.22,2.76-.31,5.89,1.63,7.87,1.73,1.79,4.47,2,6.91,2.5,12.36,2.64,19.93,15.75,21.45,28.31s-1.42,25.17-2,37.79,1.74,26.55,11.28,34.84c15,13,37.8,5.6,57.65,4.41-8.78,0-15.36-9.06-15.84-17.82s3.42-17.1,7.15-25,7.47-16.4,6.64-25.14c-1.14-12-10.6-21.61-14.22-33.16-4.22-13.44-.15-27.87,1.76-41.84,3.59-26.16-2-55.61-22.25-72.52-8.48-7.07-18.85-11.42-28.17-17.34-16.7-10.59-29.87-26.12-46.75-36.42s-40.58-14.12-55.31-.92c-5.7,5.11-9.38,12.2-15.24,17.13-11.45,9.65-29.65,9.83-38.83,21.67-7.9,10.19-5.76,24.66-3.23,37.31,3.37,16.87,1.47,30,19.5,33C602.87,410.39,622.37,416.78,634.08,410.93Z"
    transform="translate(-70.44 -55.29)"
    fill="#603556"
  />
  <path
    d="M782.64,561.45c-14.45,1.77-28.77,2.68-39.29-6.44-9.54-8.29-11.89-22.21-11.28-34.84s3.53-25.25,2-37.8-9.09-25.66-21.45-28.3c-2.44-.52-5.17-.71-6.91-2.5-1.93-2-1.85-5.12-1.63-7.88l.36-4.67a45.86,45.86,0,0,0-36.83-48.52l-.4-.08c-3.5-.69-7.12-1.38-10.59-.58-6.62,1.53-10.9,8-17,11-11.71,5.85-31.2-.54-43.47-2.55-18-2.95-16.12-16.1-19.5-33-1.89-9.44-3.56-19.9-1-28.84-.48.51-.94,1-1.38,1.61-7.9,10.19-5.76,24.66-3.23,37.31,3.37,16.87,1.47,30,19.5,33,12.26,2,31.76,8.4,43.47,2.55,6.06-3.06,10.34-9.48,17-11,3.47-.8,7.09-.11,10.59.58l.4.08a45.87,45.87,0,0,1,36.83,48.53l-.36,4.67c-.22,2.76-.31,5.89,1.63,7.87,1.73,1.79,4.47,2,6.91,2.5,12.36,2.64,19.93,15.75,21.45,28.31s-1.41,25.17-2,37.79,1.74,26.55,11.28,34.84c15,13,37.8,5.6,57.65,4.41C790,569.53,785.47,566.11,782.64,561.45Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M376.8,594.81l61.65-23a5.87,5.87,0,0,1,7.55,3.44h0a5.87,5.87,0,0,1-3.44,7.55l-61.65,23-13.22-1.32Z"
    transform="translate(-70.44 -55.29)"
    fill="#5c5c8e"
  />
  <path
    d="M444.14,573.37h0a5.87,5.87,0,0,1-3.45,7.55L379,604l-9.92-1-1.43,1.52,13.22,1.32,61.65-23a5.87,5.87,0,0,0,3.44-7.55h0a5.87,5.87,0,0,0-2.4-2.93A6.81,6.81,0,0,1,444.14,573.37Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
    opacity="0.1"
  />
  <polygon
    points="306.37 539.52 310.47 550.51 299.63 549.42 297.26 549.18 300.5 545.74 306.37 539.52"
    fill="#efc8c4"
  />
  <path
    d="M370.93,601a2.62,2.62,0,0,1,.64.69,1,1,0,0,1,0,1.07,2.13,2.13,0,0,1-.59.43,2,2,0,0,0-.88,1.48l-2.38-.23Z"
    transform="translate(-70.44 -55.29)"
    fill="#727a9c"
  />
  <path
    d="M570.37,665s53.4-11.21,143,3l-35.1-25.76-63.86-13.07-45.18,12Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M570.37,665s53.4-11.21,143,3l-35.1-25.76-63.86-13.07-45.18,12Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M564.11,677.12s26.89-72.74,165,.23l-49.57-31.9s-118.75-32.81-132.47,5Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M564.11,677.07s26.89-77.77,165,1.4l-49.57-34.6S560.75,604.63,547,645.7Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M564.11,677.1s26.89-78.92,165,.25l-49.57-34.6s-118.75-38.12-132.47,3Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M564.11,677.12s26.89-87.71,165,1.35L679.5,639.54s-118.75-40-132.47,6.16Z"
    transform="translate(-70.44 -55.29)"
    opacity="0.1"
  />
  <path
    d="M564.11,677.07s26.89-88.78,165,.28L679.5,638.42s-118.75-40-132.47,6.16Z"
    transform="translate(-70.44 -55.29)"
    fill="#fff"
  />
  <path
    d="M978.45,668.71s-33.15,35.51-3.31,52.76c0,0,3.9,4.7,9.47,2.24,0,0-1.88-1.67,1.89-4.89a22.36,22.36,0,0,0,3.55-3.9,11,11,0,0,0,2.06-6.66h0s4.34-14.09-9.45-32.38c0,0-1.25-6.12-2.31-6.79l-2.52,8.53s6.33,1.61,8.71,6.43c0,0-8.34-6.55-9.15-5.18-.16.28-1.13,4.59-1.13,4.59s11,2.84,14.44,10.4c0,0-8.89-9.13-14.82-8.77l-1.08,6.58s11.77,2.44,16,10.9c0,0-9.62-9.23-16.16-9.44l-.19,6.61s11.43,2.6,14.92,9.66c0,0-12.19-9.53-14.86-8.14,0,0,.19,6.09,1,7.68,0,0,8.16,2,9.82,6.34,0,0-8.82-5.51-9.58-4.67,0,0,2.37,7.86,5.67,11.21,0,0-5.24-4.59-6.88-10.78,0,0-2.22,3.87-1.66,7.67,0,0-3.27-3.62,1.11-9.58,0,0-1.6-6.2-1.2-7.18,0,0-5.15,5.27-6.47,10,0,0-1-5.92,6.46-11.71l0-6.66s-7.18,6.61-8.66,10.7c0,0-.1-6.2,8.81-12.37l1-6.47s-6.62,5.22-9.25,9.42c0,0,1.14-5.78,9.6-11.26l1.17-4.24s-4.76,3.9-6,5.14-1.71,1-1.71,1a21,21,0,0,1,8.2-7.94S979,668.94,978.45,668.71Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M1126.64,90.91s-44.29,20-23.41,47.39c0,0,1.79,5.85,7.87,5.73,0,0-1.09-2.27,3.63-3.79a21.91,21.91,0,0,0,4.78-2.23,11,11,0,0,0,4.47-5.35h0s9.44-11.32,3.77-33.51c0,0,1.21-6.13.49-7.16l-5.62,6.9s5.22,3.92,5.56,9.29c0,0-5.16-9.26-6.44-8.3-.26.19-2.81,3.79-2.81,3.79s9,6.86,9.31,15.17c0,0-4.68-11.86-10.3-13.82l-3.53,5.66s9.92,6.79,10.58,16.23c0,0-5.32-12.22-11.27-14.94l-2.73,6s9.55,6.81,10,14.67c0,0-7.57-13.5-10.57-13.24,0,0-2.17,5.68-2,7.47,0,0,6.74,5,6.62,9.64,0,0-6-8.48-7-8,0,0-.85,8.16.91,12.53,0,0-3.07-6.26-2.19-12.6,0,0-3.55,2.72-4.49,6.44,0,0-1.62-4.61,4.72-8.42,0,0,.91-6.33,1.66-7.08,0,0-6.79,2.87-9.81,6.69,0,0,1.35-5.85,10.48-8.31l2.6-6.12s-9.17,3.32-12.12,6.52c0,0,2.3-5.76,12.9-8l3.41-5.58s-8.12,2.27-12.17,5.12c0,0,3.29-4.88,13.21-6.68l2.71-3.46s-5.9,1.76-7.55,2.42-2,.27-2,.27A21,21,0,0,1,1121,98.09S1127,91.31,1126.64,90.91Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M706.27,103.29s-66.54,19-34.19,47.28c0,0,2.87,6,12.08,6,0,0-1.72-2.32,5.4-3.73a42.29,42.29,0,0,0,7.18-2.12,12.81,12.81,0,0,0,6.62-5.29h0s14-11.2,4.81-33.78c0,0,1.67-6.16.55-7.22l-8.32,6.82s8,4.11,8.67,9.54c0,0-8.07-9.49-10-8.56-.39.19-4.16,3.75-4.16,3.75s13.88,7.18,14.51,15.59c0,0-7.4-12.11-16-14.24l-5.2,5.62s15.2,7.13,16.45,16.69c0,0-8.38-12.49-17.46-15.4l-4,6s14.64,7.14,15.6,15.1c0,0-11.83-13.85-16.37-13.68,0,0-3.13,5.7-2.85,7.51,0,0,10.34,5.28,10.29,9.92,0,0-9.34-8.74-10.88-8.28,0,0-1.06,8.23,1.72,12.69,0,0-4.82-6.41-3.66-12.79,0,0-5.29,2.65-6.62,6.38,0,0-2.58-4.69,6.92-8.37,0,0,1.21-6.38,2.32-7.12,0,0-10.2,2.72-14.67,6.5,0,0,1.88-5.88,15.64-8.12l3.78-6.12s-13.8,3.12-18.18,6.27c0,0,3.33-5.76,19.33-7.76l5-5.55s-12.24,2.07-18.3,4.85c0,0,4.85-4.85,19.82-6.4l4-3.42s-8.89,1.62-11.37,2.24-3,.22-3,.22a39.39,39.39,0,0,1,16-3.92S706.85,103.71,706.27,103.29Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M902.58,844.71s33.5-35.19,3.83-52.73c0,0-3.86-4.74-9.45-2.34,0,0,1.87,1.69-1.93,4.88a22.57,22.57,0,0,0-3.59,3.86,10.93,10.93,0,0,0-2.12,6.64h0s-4.49,14.05,9.13,32.47c0,0,1.19,6.13,2.24,6.82l2.61-8.51s-6.32-1.67-8.65-6.51c0,0,8.27,6.62,9.09,5.26.17-.28,1.18-4.57,1.18-4.57s-11-3-14.34-10.54c0,0,8.8,9.22,14.74,8.91l1.14-6.57s-11.74-2.55-15.91-11c0,0,9.53,9.32,16.07,9.6l.25-6.62S895.46,811,892,803.9c0,0,12.1,9.66,14.78,8.29,0,0-.13-6.08-1-7.68,0,0-8.14-2.14-9.76-6.44,0,0,8.77,5.6,9.53,4.76,0,0-2.29-7.88-5.56-11.26,0,0,5.2,4.64,6.78,10.84,0,0,2.26-3.85,1.73-7.65,0,0,3.24,3.66-1.2,9.57,0,0,1.54,6.22,1.13,7.19,0,0,5.2-5.22,6.56-9.89,0,0,1,5.93-6.57,11.64l-.1,6.66s7.24-6.54,8.76-10.62c0,0,0,6.21-8.93,12.29l-1,6.46s6.67-5.16,9.34-9.33c0,0-1.2,5.76-9.71,11.16l-1.21,4.23s4.8-3.85,6.08-5.08,1.72-1,1.72-1a20.93,20.93,0,0,1-8.28,7.86S902.08,844.47,902.58,844.71Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M575.85,56.53s5.71,48.24,38.15,36.6c0,0,6.11.05,7.83-5.79,0,0-2.5.36-2.52-4.6a22.39,22.39,0,0,0-.69-5.23,10.92,10.92,0,0,0-3.75-5.87h0S606.91,59.22,584,58c0,0-5.48-3-6.68-2.62l4.89,7.43s5.31-3.8,10.53-2.5c0,0-10.38,2.14-9.85,3.64.1.31,2.76,3.82,2.76,3.82S595,61.17,603,63.42c0,0-12.71.88-16.27,5.65L591,74.15s9.46-7.42,18.67-5.21c0,0-13.26,1.4-17.65,6.25L597,79.61s9.36-7.06,17-5.16c0,0-15.16,3.16-15.82,6.09,0,0,4.77,3.78,6.53,4.18,0,0,6.84-4.91,11.18-3.41,0,0-9.9,3.18-9.75,4.3,0,0,7.53,3.26,12.22,2.9,0,0-6.89,1-12.67-1.7,0,0,1.52,4.19,4.79,6.22,0,0-4.88.15-6.61-7,0,0-5.76-2.78-6.25-3.71,0,0,.7,7.33,3.43,11.36,0,0-5.18-3-4.78-12.49l-5-4.33s.41,9.75,2.57,13.53c0,0-4.8-3.93-3.76-14.72l-4.29-4.93s-.29,8.42,1.21,13.14c0,0-3.67-4.6-2.39-14.6l-2.49-3.63s-.09,6.15,0,7.93-.34,1.95-.34,1.95A21,21,0,0,1,581,64.1S576.35,56.29,575.85,56.53Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
  <path
    d="M818.31,735.3s-46.82-13-48.32,21.44c0,0-2.36,5.64,2.39,9.44,0,0,.61-2.44,5.21-.59a22.4,22.4,0,0,0,5.1,1.35,10.93,10.93,0,0,0,6.86-1.26h0s14.5-2.66,24.34-23.34c0,0,4.85-3.93,5-5.19l-8.73,1.71s1.5,6.36-1.68,10.7c0,0,2-10.42.37-10.5-.33,0-4.59,1.11-4.59,1.11s2.56,11.06-2.55,17.61c0,0,4-12.1.93-17.2l-6.34,2.09s3.28,11.56-2.26,19.24c0,0,3.74-12.79.9-18.69L789,746.11s3,11.34-1.67,17.7c0,0,2.82-15.22.35-16.95,0,0-5.3,3-6.33,4.46,0,0,2,8.19-1.08,11.64,0,0,.8-10.37-.29-10.65,0,0-5.88,5.73-7.32,10.21,0,0,1.65-6.77,6.38-11.08,0,0-4.46-.18-7.57,2.07,0,0,1.7-4.57,9-3.44,0,0,4.76-4.29,5.81-4.38,0,0-7-2.14-11.82-1.14,0,0,4.78-3.64,13.37.32l5.92-3s-9.18-3.31-13.49-2.74c0,0,5.45-3,15,2.09l6.18-2.11s-7.68-3.45-12.62-3.85c0,0,5.65-1.65,14.42,3.32l4.3-.93s-5.66-2.42-7.35-3-1.68-1-1.68-1a21,21,0,0,1,10.83,3.6S818.34,735.85,818.31,735.3Z"
    transform="translate(-70.44 -55.29)"
    fill="#6c63ff"
    opacity="0.1"
  />
</svg>
